/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-11-19 13:36:31
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  uploadFile: " 请将文件拖到此处，或",
  clickUpload: "点击上传",
  downloadFile: "下载配置模板",
});
